import React from 'react'
import { Layout } from './Layout'
import { useProps, Params } from './useProps'

export const InOperationCheckModal = (props: Params) => {
  return <Layout {...useProps(props)} />
}
